module.exports = __webpack_public_path__ + "img/mobile/Background/background_portrait2@2x.jpg?1.0.17";